/*
* AGP events
* Forms
*/

import $ from "jquery";
//import 'bootstrap';
import * as bootstrap from 'bootstrap'
//import {Tooltip, Toast, Popover} from 'bootstrap';
import AirDatepicker from 'air-datepicker';
//import 'air-datepicker/air-datepicker.css';
import localeFr from 'air-datepicker/locale/fr';

import 'bootstrap';
import "../AGP/PLUGS/bootstrap-table-master/dist/bootstrap-table.min.js";

import Menu from "./agp_menu";

export default class Forms {


    init() {

        const menu = new Menu();
        let _this = this;

        $(document).on("submit", function (e) {

            if ($(e.target).hasClass("_no_wait") != 1) {
                $(".__wait_load").addClass("_show");
            }
            // if ($("._no_wait").length == 0) {
            //     $(".__wait_load").addClass("_show");
            //     //gsap.to($(".__wait_load"), .5, {opacity: 1, delay: .2, display: "flex"});
            // }
        });

        var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-toggle="tooltip"]'));
        //console.log(tooltipTriggerList);
        var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new bootstrap.Tooltip(tooltipTriggerEl, {"placement": "left"})
        });

        $(document).on("click", "._btn_info", function () {

            $(this).parent().toggleClass("_open");
            if ($(this).parent().hasClass("_open")) {
                $(this).html("<i class=\"fa-solid fa-circle-xmark\"></i>");
            } else {
                $(this).html("<i class=\"fa-solid fa-circle-question\"></i>");
            }


        });


        // var options = [];
        // var exampleEl = document.getElementById('example');
        // //console.log(bootstrap);
        // var tooltip = new bootstrap.Tooltip(exampleEl);

        ///////////////////////////////////////////////////////////////////////////////
        // BTN LIST
        $(document).on("click", "._btn_open_list", function () {

            var _list = $(this).data("list");
            $("._btn_list[data-list=" + _list + "]").toggleClass("_show");
            if($("._btn_list[data-list=" + _list + "]").hasClass("_show")){
                $("._btn_open_list i").removeClass("fa-chevron-down").addClass("fa-chevron-up");
            }else{
                $("._btn_ope²n_list i").removeClass("fa-chevron-up").addClass("fa-chevron-down");
            }

        });

        $(document).on("click", function (event) {
            // Check if the clicked element is not a descendant of ._btn_open_list or ._btn_list
            if (!$(event.target).closest("._btn_open_list, ._btn_list").length) {
                $("._btn_list").removeClass("_show");
                $("._btn_open_list i").removeClass("fa-chevron-up").addClass("fa-chevron-down");
            }
        });


        /////////////////////////////////////////////////////////////////////////
        // AIRDATE PICKER

        $('.airdate').each(function (i, el) {
            new AirDatepicker(el, {
                locale: localeFr,
                dateFormat: 'dd-MM-yyyy',
                inline: false,
                range: false,
                onSelect: function (dateText, inst) {
                    var _type = $(dateText.datepicker.$el).data("type");
                    if (_type != undefined) {
                        _this.valid_rangeDate(_this, _type, dateText.formattedDate);
                    }
                    _this.valid_date(dateText.formattedDate);
                }
            });
        });


        var minDate = new Date();
        minDate.setDate(minDate.getDate() + 1);

        $('.airdate_new').each(function (i, el) {
            new AirDatepicker(el, {
                locale: localeFr,
                inline: false,
                dateFormat: 'dd-MM-yyyy',
                minDate: minDate,
                range: false
            });
        });


        $('.airdate').on('input', function () {
            const inputVal = $(this).val();

            _this.valid_date(inputVal);
            // if (!dateRegex.test(inputVal)) {
            //     // input does not match the expected format
            //     $(this).addClass('_field_error');
            // } else {
            //     // input is valid
            //     $(this).removeClass('_field_error');
            // }
        });

        ///////////////////////////////////////////////////////////////////////////////

        //table sorter
        $(".table_filter").bootstrapTable({
            pagination: true,
            locale: 'fr-FR'
        });

        // expand menu
        $(document).on("click", "._expand_table", function () {

            $("._right_gestion").toggle();
            if ($("._right_gestion").is(':visible')) {
                menu.manageMenu("open");
                $("._left_gestion").css("width", "");
                $(this).find("span").html("aggrandir");
                $("i.fa-down-left-and-up-right-to-center").replaceWith("<i class='fa-solid fa-up-right-and-down-left-from-center'></i>");
            } else {
                menu.manageMenu("close");
                $("._left_gestion").css("width", "100%");
                $(this).find("span").html("réduire");
                $("i.fa-up-right-and-down-left-from-center").replaceWith("<i class='fa-solid fa-down-left-and-up-right-to-center'></i>");
            }

        });


        //SELECT CHOICE
        $("._select_choice").on("change", function () {
            var _val = $(this).val();
            if (_val != "") {
                $(".block-choice").removeClass("block-group");
                $(".block-choice[data-id=" + _val + "]").addClass("block-group");
            }
        });

        ////////////////////////////////////////////////////////
        // MULTISELECT
        $('.multiple-select').multipleSelect({
            filter: true,
            showClear: true,
            locale: 'fr-FR',
            ellipsis: true,
            minimumCountSelected: 4,
            //selectAll: true,
            filterPlaceholder: 'Rechercher..',
            // labelTemplate: function ($el) {
            //     return '<i class="fa fa-star"></i>' + $el.attr('label')
            // }
        });

        if (!window.__agpMultipleSelectScrollBound) {
            window.__agpMultipleSelectScrollBound = true;

            const getMultipleSelectList = function (target) {
                if (!target || typeof target.closest !== "function") {
                    return null;
                }
                const drop = target.closest(".ms-drop");
                if (!drop) {
                    return null;
                }
                return drop.querySelector("ul");
            };

            const normalizeWheelDelta = function (event, list) {
                if (event.deltaMode === 1) {
                    return event.deltaY * 16;
                }
                if (event.deltaMode === 2) {
                    return event.deltaY * list.clientHeight;
                }
                return event.deltaY;
            };

            document.addEventListener("wheel", function (event) {
                const list = getMultipleSelectList(event.target);
                if (!list || list.scrollHeight <= list.clientHeight) {
                    return;
                }
                list.style.overflowY = "auto";
                list.scrollTop += normalizeWheelDelta(event, list);
                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();
            }, {passive: false, capture: true});

            let lastTouchY = null;
            document.addEventListener("touchstart", function (event) {
                const list = getMultipleSelectList(event.target);
                if (!list || !event.touches || event.touches.length < 1) {
                    lastTouchY = null;
                    return;
                }
                lastTouchY = event.touches[0].clientY;
            }, {passive: true, capture: true});

            document.addEventListener("touchmove", function (event) {
                const list = getMultipleSelectList(event.target);
                if (!list || !event.touches || event.touches.length < 1 || lastTouchY === null) {
                    return;
                }
                if (list.scrollHeight <= list.clientHeight) {
                    return;
                }
                list.style.overflowY = "auto";
                list.scrollTop += lastTouchY - event.touches[0].clientY;
                lastTouchY = event.touches[0].clientY;
                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();
            }, {passive: false, capture: true});
            document.addEventListener("touchend", function () {
                lastTouchY = null;
            }, {passive: true, capture: true});
            document.addEventListener("touchcancel", function () {
                lastTouchY = null;
            }, {passive: true, capture: true});
        }


        /////////////////////////////////////////////////////
        // $('.__tags').tagEditor({
        //     placeholder: 'Ajoutez une entrée...',
        //     animateDelete: 0
        // });
        //
        // if ($('.__tags').length > 0) {
        //     $('form').on('keyup keypress', function (e) {
        //         var keyCode = e.keyCode || e.which;
        //         if (keyCode === 13) {
        //             e.preventDefault();
        //             return false;
        //         }
        //     });
        // }
        /////////////////////////////////////////////////////

        $(document).on("click", "._close_modal", function () {
            $("._modal_programme").css("display", "none");
        });

        $(document).on("focus", "input,select", function () {
            $(this).prev().prev(".__error_span").hide();
        });


        /////////////////////////// INPUT FILES

        $('.inputfile').each(function () {
            var $input = $(this),
                $label = $input.next('label'),
                labelVal = $label.html();

            $input.on('change', function (e) {
                var fileName = '';

                if (this.files && this.files.length > 1)
                    fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
                else if (e.target.value)
                    fileName = e.target.value.split('\\').pop();

                if (fileName) {
                    $label.find('._contain_label').html(fileName);
                } else {
                    $label.html(labelVal);
                }

            });

            // Firefox bug fix
            $input
                .on('focus', function () {
                    $input.addClass('has-focus');
                })
                .on('blur', function () {
                    $input.removeClass('has-focus');
                });
        });

        // $(document).on("submit", function (e) {
        //     // e.preventDefault();
        //     // console.log($(e.target).hasClass("_no_wait")!=1);
        //     // return false;
        //     if ($(e.target).hasClass("_no_wait") != 1) {
        //         //if ($("._no_wait").length == 0) {
        //         TweenMax.to($(".__wait_load"), .5, {opacity: 1, delay: .2, display: "flex"});
        //     }
        //     if ($("._load_blob").length > 0 && specific.blocTransfer === false) {
        //         TweenMax.to($(".__load_blob"), .5, {opacity: 1, delay: .2, display: "flex"});
        //     }
        // });

        $(document).on("focus", "input,select", function () {

            $(this).parent().find(".error").hide();
        });


        //////////////////////////////
        // CONTROLE DES BLOCS

        $(".__toggle_menu").each(function (e) {
            if ($(this).hasClass("__close")) {
                $(this).addClass("__closed_menu");
                $(this).parent().next(".__content_list").css("display", "none");
                $(this).html('<i class="fas fa-angle-down"></i>');
            }
        });


        $(document).on("click", ".__toggle_menu", function () {
            if ($(this).hasClass("__closed_menu")) {
                $(this).parent().next(".__content_list").slideDown(400);
                var _offset = $(this).parent().next(".__content_list").offset();
                $('html,body').animate({scrollTop: _offset.top - 100});
                $(this).html('<i class="fas fa-angle-up"></i>');
            } else {
                //console.log($(this).parent().next());
                $(this).parent().next(".__content_list").slideUp(400);
                $(this).html('<i class="fas fa-angle-down"></i>');
            }

            $(this).toggleClass("__closed_menu");

        });

        //////////////////////////////


        //******************* OUVERTURE CHAMPS
        $(document).on("click", ".__open_champs", function () {
            $(this).toggleClass("_opened");
            $(".__open_champs").not($(this)).removeClass("_opened");
            var _ch = $(this).parent().parent().next(".__champs");
            $(".__champs").not(_ch).slideUp();
            if ($(this).hasClass("_opened")) {
                $(this).parent().parent().next(".__champs").slideDown();
            } else {
                $(this).parent().parent().next(".__champs").slideUp();
            }

        });

        //********************** SELECT HIDDEN
        $(document).on("change", ".__select_choice", function () {

            var _select_type = $(this).data("select");

            if ($(this).hasClass("_bydata")) {
                var _id = ($(this).find("option:selected").data("id"));
            } else {
                var _id = $(this).val();
            }

            if (_select_type != undefined) {
                $(".block-hide[data-select=" + _select_type + "]").css("display", "none");
            } else {
                $(".block-hide").css("display", "none");
            }


            $(".block-hide[data-id=" + _id + "]").css("display", "block");

            $('.multiple-select').multipleSelect("refresh");


            $(".block-hide[data-type]").each(function (el) {
                var _id_type = $(this).data("type");
                var _split_type = _id_type.split(",");
                if (_split_type.includes(_id)) {
                    $(this).addClass("__open").css("display", "block");
                }
            });

        });

        /////////// SELECT HIDDEN / SPECIFIC CHPS BADGE
        $(document).on("change", ".__select_choice_chp", function () {
            var _group = $(this).data("group");
            var _id = $(this).val();


            $(".block-chp-group[data-group=" + _group + "] > .block-chp-hide").hide();
            $(".block-chp-group[data-group=" + _group + "] > .block-chp-hide[data-id=" + _id + "]").show();

        });

        $(document).on("click", "._open_hide", function () {
            var _id = $(this).data("id");

            $(".block-hide").css("display", "none");
            $(".block-hide[data-id=" + _id + "]").toggle();
        });

        //********************** OPEN MODAL
        $(document).on("click", ".__open_modal_id", function () {
            var _id = $(this).data("modal");
            $(".__modal[data-modal=" + _id + "]").addClass("_show");
        });


    }

    valid_date(inputVal) {
        //console.log(inputVal);
        const dateRegex = /^([0-9]{2})-([0-9]{2})-([0-9]{4})$/;
        if (!dateRegex.test(inputVal)) {
            // input does not match the expected format
            $('.airdate').addClass('_field_error');
        } else {
            // input is valid
            $('.airdate').removeClass('_field_error');
        }
    }

    valid_rangeDate(_this, type, inputVal) {
        var _other = "deb";
        if (type === "deb") {
            _other = "end";
        }
        var _input_other = $("input[data-type=" + _other + "]").val();
        if (_input_other != "") {
            console.log($("input[data-type=deb]").val());
            var date1 = _this.parseDate($("input[data-type=deb]").val());
            var date2 = _this.parseDate($("input[data-type=end]").val());
            //console.log(date1 + " - " + date2);
            if (date1.getTime() > date2.getTime()) {
                $('.airdate').addClass('_field_error');
                $("input[data-type=end]").val("");
                alert("date de début supérieure à date de fin");
            }
        }
    }

    parseDate(dateString) {
        var parts = dateString.split("-");
        var day = parseInt(parts[0], 10);
        var month = parseInt(parts[1], 10) - 1; // Months are zero-based in JavaScript Date
        var year = parseInt(parts[2], 10);

        return new Date(year, month, day);
    }
}